import { render, staticRenderFns } from "./StartupsModal.vue?vue&type=template&id=33354c05"
import script from "./StartupsModal.vue?vue&type=script&lang=js"
export * from "./StartupsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports